
export default {
  props: ["element"],
  name: "hyperCoreHtml",
};
